import { queryOptions, useQuery } from "@tanstack/react-query";

import type { Conversation } from "~/conversations/types/conversation";
import type { GetConversationParams } from "~/conversations/api/get-conversation";
import { getConversation } from "~/conversations/api/get-conversation";
import { mapConversationToModel } from "~/conversations/utils/map-conversation-to-model";

function getConversationQueryOptions(params: GetConversationParams) {
  return queryOptions({
    enabled: typeof params.conversationId === "number",
    queryKey: ["conversations", ...Object.entries(params)],
    async queryFn() {
      const conversation = await getConversation(params);
      return mapConversationToModel(conversation);
    },
  });
}

function useGetConversation<TSelect = Conversation>(
  params: GetConversationParams,
  select?: (data: Conversation) => TSelect,
) {
  return useQuery({
    ...getConversationQueryOptions(params),
    select,
  });
}

export { getConversationQueryOptions, useGetConversation };
